"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brand = brand;
function brand(value) {
    return value;
}
//# sourceMappingURL=branded-id.js.map